module.exports = __webpack_public_path__ + "static/media/footer.113fbfdc.jpg";